export default "__VITE_ASSET__BddOFGrp__"